"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductBaseExtraToJSON = exports.ProductBaseExtraFromJSONTyped = exports.ProductBaseExtraFromJSON = void 0;
var runtime_1 = require("../runtime");
function ProductBaseExtraFromJSON(json) {
    return ProductBaseExtraFromJSONTyped(json, false);
}
exports.ProductBaseExtraFromJSON = ProductBaseExtraFromJSON;
function ProductBaseExtraFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderNumber': !(0, runtime_1.exists)(json, 'orderNumber') ? undefined : json['orderNumber'],
        'brand': !(0, runtime_1.exists)(json, 'brand') ? undefined : json['brand'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
    };
}
exports.ProductBaseExtraFromJSONTyped = ProductBaseExtraFromJSONTyped;
function ProductBaseExtraToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderNumber': value.orderNumber,
        'brand': value.brand,
        'category': value.category,
    };
}
exports.ProductBaseExtraToJSON = ProductBaseExtraToJSON;
//# sourceMappingURL=ProductBaseExtra.js.map